import React from 'react';

import Footer from '../components/Footer';
import '../App.css';

const BunkerFreshWater = () => {
  return (
    <div>
      

      {/* Cover Image Section */}
      <div className="service-cover">
        <img
          src="/images/bunker.webp"
          alt="Bunker and Fresh Water Supply"
          className="service-cover-image"
        />
        <div className="service-cover-text">
          <h1>Bunker & Fresh Water Supply</h1>
          <p>Reliable Fueling and Water Solutions, Wherever Your Fleet Is</p>
        </div>
      </div>

      {/* Main Content */}
      <section className="service-section container">
        <div className="intro-text">
          <h2>Global Bunkering & Potable Water Supply for Maritime Operations</h2>
          <p>
            At Blue Waves Ship Management, we understand the critical role that fuel and fresh water play in
            sustaining maritime operations. Our Bunker and Fresh Water Supply services are tailored to ensure
            vessels receive top-grade fuel and potable water—on time, at the right place, and with complete
            transparency.
          </p>
          <p>
            With a global network of suppliers and strict quality control protocols, we guarantee cost-effective
            and compliant delivery services that support smooth voyages and minimize delays.
          </p>
        </div>

        {/* Services Grid */}
        <div className="service-grid">
          <div className="service-card">
            <img src="/images/bunker-fuel.webp" alt="Bunker Fuel Supply" className="service-card-image" />
            <div className="service-card-content">
              <h3>Reliable Bunker Fuel Supply</h3>
              <ul>
                <li>Marine gas oil (MGO) and heavy fuel oil (HFO)</li>
                <li>Grade-specific fuel for all engine types</li>
                <li>Available at all major ports worldwide</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/water.webp" alt="Fresh Water Supply" className="service-card-image" />
            <div className="service-card-content">
              <h3>Fresh Water Delivery</h3>
              <ul>
                <li>Portside and offshore supply</li>
                <li>Sanitation-compliant potable water</li>
                <li>Delivered via barge or tanker truck</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/qualityassurance.webp" alt="Quality Assurance" className="service-card-image" />
            <div className="service-card-content">
              <h3>Quality Assurance & Monitoring</h3>
              <ul>
                <li>ISO-standard bunkering practices</li>
                <li>Sampling and testing at every delivery</li>
                <li>Verified quantity and specification certificates</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/coordination.webp" alt="Coordination & Documentation" className="service-card-image" />
            <div className="service-card-content">
              <h3>Logistics & Documentation</h3>
              <ul>
                <li>Coordinated scheduling with port agents</li>
                <li>End-to-end documentation & compliance</li>
                <li>Real-time status tracking</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BunkerFreshWater;
